<template>
  <b-spinner
    :type="spinnerType"
    :variant="spinnerVariant"
    :small="smallSize"
    :style="customSizeStyle"
    :class="customClass"
    :label="accessibilityLabel"
    v-if="show"
  >
    <slot name="label"></slot>
  </b-spinner>
</template>

<script>
export default {
  name: 'Spinner',
  props: {
    // Controls visibility of the spinner
    show: {
      type: Boolean,
      default: true, // Keep default true to maintain backward compatibility if it was always visible before
    },
    // Type of spinner: 'border' or 'grow'
    spinnerType: {
      type: String,
      default: 'border', // Matches b-spinner's default
      validator: (value) => ['border', 'grow'].includes(value),
    },
    // Theme variant for color (e.g., 'primary', 'secondary', 'success', 'light', 'dark')
    spinnerVariant: {
      type: String,
      default: null, // Uses current font color if null, matches b-spinner's default
      // Optional: Add validator if you want to restrict to specific variants
      // validator: (value) => ['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'light', 'dark'].includes(value),
    },
    // Small size flag
    smallSize: {
      type: Boolean,
      default: true, // Matches b-spinner's default
    },
    // Custom size via inline style (takes precedence over 'small')
    size: {
      type: String,
      default: null, // e.g., '2rem', '50px'. If null, 'small' prop or default size applies.
      // No strict validator needed, but ensure valid CSS dimension units are passed.
    },
    // Accessibility label (crucial!)
    accessibilityLabel: {
      type: String,
      default: 'Loading...', // Provide a sensible default, but encourage override via prop
    },
    // Pass additional CSS classes to the spinner element
    customClass: {
      type: [String, Array, Object],
      default: null, // Allows passing classes like 'mr-2', ['class1', 'class2'], or { 'class-name': true }
    },
    // Add more props if specific layout classes are commonly needed
    // e.g., a 'centered' prop that adds 'd-flex justify-content-center' to a parent div
  },
  computed: {
    // Dynamically generate inline style for custom size
    customSizeStyle() {
      if (this.size) {
        return {
          width: this.size,
          height: this.size,
        };
      }
      return null;
    },
  },
};
</script>

